import React from 'react';
export function Experience() {
  return <section className="py-10 bg-blue-600 text-white" data-id="element-128">
      <div className="container mx-auto px-4" data-id="element-129">
        <div className="max-w-3xl mx-auto text-center" data-id="element-130">
          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-xl mb-12" data-id="element-131">
            <p className="text-xl italic mb-6" data-id="element-132">
              Cierra los ojos un momento… Imagina colocar este gorro
              terapéutico, sin esfuerzo, sin ruido.
            </p>
            <p className="text-xl italic mb-6" data-id="element-133">
              Sientes el frío o el calor envolverte… Tus músculos sueltan. Tu
              cabeza descansa. Tu sistema se reinicia.
            </p>
            <p className="text-xl italic mb-6" data-id="element-134">
              Y todo esto… sin dañar tu cuerpo.
            </p>
          </div>
          <p className="text-xl font-semibold" data-id="element-135">
            🌸 Porque tu cuerpo fue diseñado para sanar. Solo necesitaba ayuda.
          </p>
        </div>
      </div>
    </section>;
}